import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionAnalyzeLegacyPatients(
    $input: AnalyzeLegacyPatientsInput!
  ) {
    actionAnalyzeLegacyPatients(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      analysisData
    }
  }
  ${ErrorMessageInfo}
`;
